(function () {
    'use strict';

    angular.module('app.tenantReporting', [
        'app.core',
        'app.widgets'
    ]);
})();
